import React from "react";
import InstructorLayout from "@/components/InstructorLayout";
import MessagesInbox from "@/components/MessagesInbox";

export default function InstructorMensajes() {
  return (
    <InstructorLayout>
      <div className="mb-4">
        <p className="text-xs uppercase tracking-widest text-[#F26A21] font-bold">Instructor</p>
        <h1 className="mt-1 text-3xl font-bold text-white font-display">Mensajes</h1>
        <p className="mt-1 text-sm text-gray-400">Conversaciones con tus alumnos.</p>
      </div>
      <MessagesInbox role="instructor" />
    </InstructorLayout>
  );
}
